// Frontend mirror of backend/formazione_categories.py.
// Every category defined here MUST exist in the backend module with the
// same `key`; the backend classifier is the authoritative one. On the
// frontend we use this list only for chip labels and (rarely) to
// classify records that don't yet carry a `categoria` field.

const norm = (s) => {
  if (!s) return '';
  return String(s)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
};

export const CATEGORIES = [
  { key: 'primo_soccorso',       label: 'Primo soccorso',
    match: /\b(primo\s*soccorso|p\s*s\b|bls|defibrill)\b/ },
  { key: 'antincendio',          label: 'Antincendio',
    match: /\b(antincend|incendi)/ },
  { key: 'haccp',                label: 'HACCP',
    match: /\b(haccp|aliment)/ },

  { key: 'base_specifica',       label: 'Base + specifica',
    match: /^\s*lavoratori\s*$|base\s*\+?\s*specifica|corso\s*base\s+e\s+specific/ },
  { key: 'generale_lavoratori',  label: 'Generale lavoratori',
    match: /\bgeneral/ },
  { key: 'specifica_lavoratori', label: 'Specifica lavoratori',
    match: /\bspecific|rischio\s+(basso|medio|alto)/ },

  { key: 'rspp',                 label: 'RSPP',
    match: /\brspp\b|responsabile\s+servizio\s+prevenzione/ },
  { key: 'rls',                  label: 'RLS',
    match: /\brls\b|rappresentante.*lavoratori\s+sicurezza/ },

  { key: 'preposto',             label: 'Preposto',            match: /prepost/ },
  { key: 'dirigente',            label: 'Dirigente',           match: /dirigent/ },
  { key: 'datore_lavoro',        label: 'Datore di lavoro',
    match: /datore\s+di?\s*lavoro(?!.*rspp)|\bdlsi\b/ },
  { key: 'datore_lavoro_rspp',   label: 'Datore di lavoro/RSPP',
    match: /datore\s+di?\s*lavoro.*rspp|\bdl\b\s*rspp|dlrspp/ },
  { key: 'formatore_sicurezza',  label: 'Formatore sulla sicurezza',
    match: /formatore.*sicurezza|formatori?\s+in?\s*materia\s+sicurezza/ },
  { key: 'resp_trattamento_dati', label: 'Responsabile trattamento dati',
    match: /responsabile.*trattamento.*dati|privacy|gdpr/ },

  { key: 'pes_pav',              label: 'PES-PAV',
    match: /pes\s*pav|\bpes\b|\bpav\b|rischio\s+elettric|elettric|cei\s*11/ },
  { key: 'carrelli',             label: 'Carrelli elevatori',
    match: /carrell|mulett|forklift/ },
  { key: 'ple',                  label: 'PLE / Piattaforme',
    match: /\bple\b|piattaform/ },
  { key: 'carroponte',           label: 'Carroponte',
    match: /carripont|carropont|carro\s*ponte|mezzi\s+di\s+sollevament|sollevament/ },
  { key: 'gru',                  label: 'Gru',
    match: /\bgru\b|autogru|gru\s+mobile|gru\s+cingolat/ },
  { key: 'ponteggi',             label: 'Ponteggi',            match: /ponteggi/ },
  { key: 'trabattello',          label: 'Trabattello',         match: /trabattell|trabatell/ },
  { key: 'scale_portatili',      label: 'Scale portatili',
    match: /scale\s+portatil|scal\w*\s+portatil/ },
  { key: 'motoseghe',            label: 'Motoseghe, decespugliatore, roncola, motozappa e forbici da potatura',
    match: /motoseg|decespugl|roncola|motozap|forbic|potatur/ },
  { key: 'mietitrebbia',         label: 'Mietitrebbia',        match: /mietitrebb/ },
  { key: 'movimento_terra',      label: 'Movimento terra',
    match: /movimento\s+terra|macch\w*\s+movimento|escavat|pala\s+meccan|bulldozer|ruspa|caricator\w*\s+frontal|\bterne\b/ },
  { key: 'trattori_agricoli_forestali', label: 'Trattori agricoli e forestali',
    match: /trattor/ },
  { key: 'saldatori',            label: 'Saldatori',           match: /saldator|saldatur/ },
  { key: 'laser',                label: 'Laser',               match: /\blaser\b/ },

  { key: 'confinati',            label: 'Spazi confinati',
    match: /confinat|d\s*p\s*r\s*177/ },
  { key: 'dpi3',                 label: 'DPI III categoria',
    match: /\bdpi\b.*iii|iii.*\bdpi\b|dpi\s*3|terza\s+categori|cadut[ae]\s+dall|imbragat|imbrac|anticadut|lavori\s+in\s+quota|quota/ },
  { key: 'chimico',              label: 'Chimico',
    match: /chimic|cancerog|amiant|rischio\s+biolog/ },
  { key: 'diisocianati',         label: 'Di-isocianati',
    match: /di\s*isocian|diisocian|iso[- ]?cian/ },
  { key: 'alcool',               label: 'Alcool',
    match: /\balco[oò]l|alcool/ },

  { key: 'fitosanitari',         label: 'Fitosanitari',
    match: /addett.*fitosanitar|fitosanitar/ },
  { key: 'responsabile_piscina', label: 'Responsabile piscina',
    match: /responsabil.*piscin|resp\s*piscin/ },
  { key: 'integrazione_resp_osa', label: 'Integrazione resp./OSA',
    match: /integrazion.*(resp|osa)|resp.*osa\b|\bosa\b/ },

  { key: 'tecnico_installatore_manutentore', label: 'Tecnico installatore/manutentore',
    match: /(estintor|idrant|sprinkler|serrament.*tagliafuoco|tagliafuoco.*serrament|porte\s+tagliafuoco|evacuator\w*\s+fumo|rivelaz.*incendi)|\b(efc|irai)\b|(installat|manutent).*(antincend|impianti)/ },

  { key: 'aggiornamento',        label: 'Aggiornamento',       match: /aggiornament/ },
];

export const CATEGORY_LABELS = CATEGORIES.reduce(
  (acc, c) => { acc[c.key] = c.label; return acc; },
  { altro: 'Altro' },
);

export const classifyCorso = (titolo) => {
  const n = norm(titolo);
  if (!n) return 'altro';
  for (const c of CATEGORIES) {
    if (c.match.test(n)) return c.key;
  }
  return 'altro';
};

export const labelFor = (key) => CATEGORY_LABELS[key] || key || 'Altro';
